import { ROUTE_NARRATIVE_COMMUNITY } from '@/constants/routes';
import { useCompanyCountryMatch } from '@/pages/StockPage/hooks/useCompanyCountryMatch';
import { getPath } from '@/router/utils';
import { Button } from '@simplywallst/ui-core/next';
import { useTracking } from 'react-tracking';

type Props = {
  canonicalUrl: string;
  country: string;
  industry: string;
  companyName: string;
  companyNarrativeName: string;
  exchangeTicker: string;
  communityNarrativeCount: number;
};

export const CompanyNarrativeButtonExperiment = ({
  canonicalUrl,
  country,
  industry,
  companyName,
  companyNarrativeName,
  exchangeTicker,
  communityNarrativeCount,
}: Props) => {
  const { trackEvent } = useTracking();

  // Allow only companies within Canadian market
  const allowedExchangeCountryIso = 'CA';

  const { isMatch, status, stockUrl } = useCompanyCountryMatch(
    canonicalUrl,
    allowedExchangeCountryIso
  );

  const isMatchingCompany = isMatch && status === 'success';

  if (!isMatchingCompany && communityNarrativeCount === 0) return;

  if (!isMatchingCompany && communityNarrativeCount > 0) {
    return (
      <Button
        variant="secondary"
        href={getPath({
          type: ROUTE_NARRATIVE_COMMUNITY,
          payload: {
            country,
            industry,
            companyname: companyName,
            exchange_ticker: exchangeTicker,
          },
        })}
        onClick={() => {
          trackEvent({
            action: 'click',
            modifier: 'view-all',
          });
        }}
      >
        View {companyNarrativeName} Community
      </Button>
    );
  }

  return (
    <Button
      variant="secondary"
      href={stockUrl}
      onClick={() => {
        trackEvent({
          action: 'click',
          modifier: 'view-all',
        });
      }}
    >
      View Stock Community
    </Button>
  );
};
